import React from 'react';

import { RecommendationModal } from 'ui-widgets';
import { SetSnackbarInfoPayloadType } from '../components/Snackbar';
import { useLabels } from '../hooks/useLabels';
import { useRecommendationModalHandlers } from '../hooks/useRecommendationModalHandlers';
import { useRecommendationModalState } from '../hooks/useRecommendationModalState';
import { useRecommendationsModalAnalytics } from '../hooks/useRecommendationsModalAnalytics';
import { useRecommendationsModalAnalyticsListeners } from '../hooks/useRecommendationsModalAnalyticsListeners';
import { useRecommendationsModalListeners } from '../hooks/useRecommendationsModalListeners';

type RecommendationsModalContainerProps = {
  toggleSnackbarInfo: (props: SetSnackbarInfoPayloadType) => void;
};

export const RecommendationsModalContainer: React.FC<
  RecommendationsModalContainerProps
> = ({ toggleSnackbarInfo }) => {
  const {
    isOpen,
    modalProps,
    proposal,
    xHeader,
    isViewEventTriggered,
    closeTimeoutRef,
    recommendationsIds,
    setIsOpen,
    setModalProps,
    setProposal,
    setXHeader,
    setIsViewEventTriggered,
    handleCloseClick,
  } = useRecommendationModalState();

  const { textLabels } = useLabels();
  const { handleAddToCart, handleMouseOver, handleRecommendedItemUrlClick } =
    useRecommendationModalHandlers({
      modalProps,
      recommendationsIds,
      xHeader,
      closeTimeoutRef,
      setModalProps,
      textLabels,
      toggleSnackbarInfo,
    });

  // listeners
  useRecommendationsModalAnalyticsListeners(setModalProps);
  useRecommendationsModalAnalytics(
    isOpen,
    modalProps,
    proposal,
    isViewEventTriggered,
    setIsViewEventTriggered,
  );
  useRecommendationsModalListeners({
    isOpen,
    closeTimeoutRef,
    textLabels,
    setModalProps,
    setIsOpen,
    setIsViewEventTriggered,
    setProposal,
    setXHeader,
    handleCloseClick,
  });

  return (
    <RecommendationModal
      isOpen={isOpen}
      labels={{
        bannerLabel: modalProps.bannerLabel,
        bannerShippingTitle: modalProps.bannerShippingTitle,
        bannerShippingSubtitle: modalProps.bannerShippingSubtitle,
        bottomBannerTitle: textLabels.bottomBannerTitle,
        bottomBannerSubtitle: textLabels.bottomBannerSubtitle,
      }}
      controlRuleId={modalProps?.controlRuleId ?? null}
      addedMaterialImage={modalProps.addedMaterialImage}
      recommendedItems={modalProps.recommendedItems}
      backdropTopPadding={modalProps.backdropTopPadding ?? 0}
      // @ts-expect-error
      proposal={proposal}
      onClose={handleCloseClick}
      onAddToCart={handleAddToCart}
      onRecommendedItemUrlClick={handleRecommendedItemUrlClick}
      onMouseOver={handleMouseOver}
    />
  );
};
